import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

// components
import Loader from '../../components/Loader/Loader';
import LeadBankOffers from '../../components/CreditApplications/LeadBankOffers';
import LeadCreditApplicationDetails from '../../components/CreditApplications/LeadCreditApplicationDetails';
import ReassignCarButton from '../../components/CreditApplications/ReassignCarButton';
import Status from '../../components/Status';
import leadDealStatusColor from '../../utils/leadDealStatusColor';

// api
import getLeadCard from '../../api/leads/getLeadCard';
import getDealCars from '../../api/deals/getDealCars';
import formatNumber from '../../utils/formatNumber';
import formatDate from '../../utils/formatDate';
import fixDateTimezone from '../../utils/fixDateTimezone';

const formatRemaining = (ms) => {
  if (ms <= 0) return null;
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours} Ñ ${minutes} Ð¼Ð¸Ð½` : `${minutes} Ð¼Ð¸Ð½`;
};

const Field = ({ label, value }) => (
  <div>
    <p style={{ color: '#8B8B8B', fontSize: 12, lineHeight: '16px', marginBottom: 4 }}>{label}</p>
    <p style={{ fontSize: 14, lineHeight: '20px', wordBreak: 'break-word' }}>{value || 'â'}</p>
  </div>
);

const SectionTitle = ({ children, style }) => (
  <h3 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 16px', ...style }}>{children}</h3>
);

// ÐÐ°ÑÑ ÑÐ´ÐµÐ»Ð¾Ðº Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð² UTC; Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð² Ð¾Ð½Ð¸ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑÑÑ ÑÐµÑÐµÐ· ÑÑÑ Ð¿Ð°ÑÑ
// ÑÑÐ¸Ð»Ð¸Ñ, Ð° ÑÑÑ Ð´Ð°ÑÐ°, ÑÐ½ÑÑÐ°Ñ Ð½Ð° Ð³Ð¾Ð»Ð¾Ð¼ new Date(), Ñ Ð²ÐµÑÐµÑÐ½Ð¸Ñ ÑÐ´ÐµÐ»Ð¾Ðº ÑÐµÐ·Ð¶Ð°Ð»Ð° Ð½Ð° Ð´ÐµÐ½Ñ.
const dealDate = (value) => (value ? formatDate(fixDateTimezone(value)) : '');

const TtlCountdown = ({ expiresAt }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(interval);
  }, []);

  if (!expiresAt) return null;
  const remaining = formatRemaining(new Date(expiresAt).getTime() - now);
  if (!remaining) return null;

  return (
    <div style={{ background: '#FFF6E5', border: '1px solid #F5C56B', borderRadius: 8, padding: '10px 16px', marginBottom: 20 }}>
      ÐÐ°Ð½ÐºÐ¸ ÐµÑÑ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ â Ð¾ÑÑÐ°Ð»Ð¾ÑÑ {remaining}.
    </div>
  );
};

/**
 * Ð¢Ð°Ð± "ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¸ Ð±Ð°Ð½ÐºÐ¸" Ð½Ð° ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð»Ð¸Ð´Ð°: ÑÑÐ¾ Ð²ÑÐ±ÑÐ°Ð» ÐºÐ»Ð¸ÐµÐ½Ñ (Ð¼Ð°ÑÐ¸Ð½Ð°,
 * ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, ÑÐ²ÐµÑ), ÑÑÐ¾ Ð¾Ð½ ÑÐºÐ°Ð·Ð°Ð» Ð² ÑÐ°Ð¼Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐµ, Ð¸ Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¿Ð¾
 * Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ¹ ÑÐ´ÐµÐ»ÐºÐµ Ð»Ð¸Ð´Ð°. ÐÑÐ»Ð¸ Ñ Ð»Ð¸Ð´Ð° Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ´ÐµÐ»Ð¾Ðº (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÑÑÐ°ÑÐ°Ñ
 * Ð¿ÑÐ¾ÑÑÐ¾ÑÐµÐ½Ð° Ð¿Ð¾ TTL, Ð·Ð°Ð²ÐµÐ´ÐµÐ½Ð° Ð½Ð¾Ð²Ð°Ñ) â Ð°ÐºÑÐ¸Ð²Ð½Ð°Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ Ð¿Ð¾Ð»Ð½Ð¾ÑÑÑÑ,
 * Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ â ÑÐ²ÑÑÐ½ÑÑÑÐ¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ ÑÐ¾ ÑÑÐ°ÑÑÑÐ¾Ð¼.
 */
const LeadDealInfo = () => {
  const { id } = useParams();
  const [lead, setLead] = useState();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  const activeDeal = lead?.deals?.[0];
  const historyDeals = lead?.deals?.slice(1) || [];
  const activeCar = cars?.[0];
  const carReleased = !!activeCar?.stockReturnedAt;

  const init = () => {
    getLeadCard({ id })
      .then((res) => {
        setLead(res.data);
        const dealId = res.data?.deals?.[0]?.id;
        if (dealId) {
          return getDealCars({ id: dealId }).then((carsRes) => setCars(carsRes.data?.cars || []));
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    init();
  }, [id]);

  if (loading) return <Loader />;

  // ÐÐ¾ÐºÐ° ÑÐ´ÐµÐ»ÐºÐ¸ Ð½ÐµÑ, Ð¼Ð°ÑÐ¸Ð½Ð° Ð¸Ð·Ð²ÐµÑÑÐ½Ð° Ð¸Ð· Ð»Ð¸Ð´Ð° (ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾Ð»Ð¾Ð¶Ð¸Ð» ÐµÑ Ð² ÐºÐ¾ÑÐ·Ð¸Ð½Ñ) â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ
  // ÑÑÐ¾ Ð½ÑÐ¶Ð½Ð¾ Ð²Ð¸Ð´ÐµÑÑ ÑÑÐ°Ð·Ñ, Ð° Ð½Ðµ Ð¿Ð¾ÑÐ»Ðµ ÐºÐ¾Ð½Ð²ÐµÑÑÐ°ÑÐ¸Ð¸ Ð»Ð¸Ð´Ð° Ð² ÑÐ´ÐµÐ»ÐºÑ.
  const leadCar = lead?.car;
  const car = activeCar
    ? {
        mark: activeCar.mark,
        model: activeCar.model,
        complectation: activeCar.complectation?.title || activeCar.complectation?.name,
        color: activeCar.color,
        issueYear: activeCar.issueYear,
        vin: activeCar.vin,
        city: activeCar.city?.title,
        engine_volume: activeCar.engine_volume,
        price: activeCar.price,
      }
    : leadCar;

  return (
    <div style={{
      padding: 24,
      border: '1px solid #E5E5E5',
      borderRadius: 8,
      background: '#FFFFFF',
      marginTop: 20
    }}>
      {/* Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð´Ð¾ ÑÑÐ¾Ð³Ð¾ Ð²Ð¸Ð´ÐµÐ» ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð¿ÑÐ¾ÑÐ»ÑÐ¼ ÑÐ´ÐµÐ»ÐºÐ°Ð¼: Ð¿Ð¾ ÑÐµÐºÑÑÐµÐ¹
          Ð±ÑÐ»Ð¸ Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð², Ð½Ð¾ Ð½Ðµ ÑÐ¾, Ð² ÐºÐ°ÐºÐ¾Ð¼ Ð¾Ð½Ð° ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸. Ð¦Ð²ÐµÑ â ÑÐ¾Ñ Ð¶Ðµ, ÑÑÐ¾ Ð²
          ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð², ÑÑÐ¾Ð±Ñ Â«Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¾Â» ÑÐ¸ÑÐ°Ð»Ð¾ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾ Ð² Ð¾Ð±Ð¾Ð¸Ñ Ð¼ÐµÑÑÐ°Ñ. */}
      {activeDeal && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
          <Link to={`/deals/deal/${activeDeal.id}/main-info`} style={{ fontSize: 16, fontWeight: 600, color: 'inherit' }}>
            Ð¡Ð´ÐµÐ»ÐºÐ° â{activeDeal.id} Ð¾Ñ {dealDate(activeDeal.createdAt)}
          </Link>
          {lead?.dealStatus?.title && (
            <div style={{ maxWidth: 240 }}>
              <Status status={lead.dealStatus.title} color={leadDealStatusColor(lead.dealStatus)} />
            </div>
          )}
        </div>
      )}

      {activeDeal && <TtlCountdown expiresAt={activeDeal.ttlExpiresAt} />}

      {
        car ? <SectionTitle>{activeCar ? 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð² ÑÐ´ÐµÐ»ÐºÐµ' : 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}</SectionTitle> : null
      }
      {carReleased && (
        <div style={{ background: '#FDEDED', border: '1px solid #EE7171', borderRadius: 8, padding: '10px 16px', marginBottom: 16 }}>
          Ð­ÑÐ° Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¶Ðµ Ð½Ðµ Ð·Ð°ÐºÑÐµÐ¿Ð»ÐµÐ½Ð° Ð·Ð° ÑÐ´ÐµÐ»ÐºÐ¾Ð¹. ÐÐ¾Ð´Ð±ÐµÑÐ¸ÑÐµ Ð´ÑÑÐ³ÑÑ Ð½Ð¸Ð¶Ðµ.
        </div>
      )}
      {/* ÐÐ°ÑÐ¸Ð½Ñ Ð¿Ð¾ÑÑÐ¸ Ð²ÑÐµÐ³Ð´Ð° Ð´ÐµÑÐ¶Ð¸Ñ ÑÐ°Ð¼ ÐºÐ»Ð¸ÐµÐ½Ñ â ÑÑÐ¾ Ð½Ð¾ÑÐ¼Ð°Ð»ÑÐ½Ð¾, Ð° Ð½Ðµ Ð¿Ð¾Ð²Ð¾Ð´ Ð¿ÑÐ³Ð°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°.
          ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ ÐµÑ Ð·Ð°Ð½ÑÐ» ÐºÑÐ¾-ÑÐ¾ Ð´ÑÑÐ³Ð¾Ð¹ Ð¸Ð»Ð¸ ÐµÑ Ð²Ð¾Ð²ÑÐµ Ð½Ðµ Ð¾ÑÑÐ°Ð»Ð¾ÑÑ. */}
      {!activeCar && leadCar?.reservedByClient && (
        <p style={{ color: '#8B8B8B', marginBottom: 16 }}>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÐºÐ¾ÑÐ·Ð¸Ð½Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°.</p>
      )}
      {car ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, marginBottom: 30 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
            gap: '20px 24px',
            flex: 1,
            opacity: carReleased ? 0.5 : 1
          }}>
            <Field label="ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ" value={[car.mark, car.model].filter(Boolean).join(' ')} />
            <Field label="ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ" value={car.complectation} />
            <Field label="Ð¦Ð²ÐµÑ" value={car.color} />
            <Field label="ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°" value={car.issueYear} />
            <Field label="VIN" value={car.vin} />
            <Field label="ÐÐ¾ÑÐ¾Ð´" value={car.city} />
            <Field label="ÐÐ²Ð¸Ð³Ð°ÑÐµÐ»Ñ" value={car.engine_volume ? `${car.engine_volume} ÑÐ¼Â³` : null} />
            <Field label="Ð¦ÐµÐ½Ð°" value={car.price ? `${formatNumber(car.price)} â¸` : null} />
          </div>
          {activeCar && (
            <ReassignCarButton
              orderId={activeCar?.orderId}
              complectationId={activeCar?.complectationId}
              color={activeCar?.color}
              onDone={init}
            />
          )}
        </div>
      ) : (
        null
      )}

      {!activeDeal ? (
        <p style={{ color: '#8B8B8B', fontSize: 14 }}>ÐÐ¾ ÑÑÐ¾Ð¼Ñ Ð»Ð¸Ð´Ñ ÐµÑÑ Ð½ÐµÑ ÑÐ´ÐµÐ»ÐºÐ¸ â Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸ Ð½Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐ»Ð¸ÑÑ.</p>
      ) : (
        <>
          <SectionTitle>ÐÐ°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸</SectionTitle>
          <LeadCreditApplicationDetails chunkId={activeDeal.chunkId} />

          <SectionTitle style={{ margin: '30px 0 16px' }}>ÐÐ°Ð½ÐºÐ¸</SectionTitle>
          <LeadBankOffers chunkId={activeDeal.chunkId} dealStatusId={activeDeal.statusId} onOfferSelected={init} />
        </>
      )}

      {historyDeals.length > 0 && (
        <>
          <SectionTitle style={{ margin: '30px 0 16px' }}>ÐÑÐµÐ´ÑÐ´ÑÑÐ¸Ðµ ÑÐ´ÐµÐ»ÐºÐ¸ Ð»Ð¸Ð´Ð°</SectionTitle>
          {historyDeals.map((deal) => (
            <Link
              key={deal.id}
              to={`/deals/deal/${deal.id}/main-info`}
              style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '14px 0', borderBottom: '1px solid #E5E5E5', color: 'inherit', textDecoration: 'none' }}
            >
              <span>Ð¡Ð´ÐµÐ»ÐºÐ° â{deal.id} Ð¾Ñ {dealDate(deal.createdAt)}</span>
              <span>{deal.status?.title}</span>
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

export default LeadDealInfo;
